import { render, staticRenderFns } from "./SitemanagerInvoiceTab.vue?vue&type=template&id=0963811c&"
import script from "./SitemanagerInvoiceTab.vue?vue&type=script&lang=js&"
export * from "./SitemanagerInvoiceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports